import { Typography } from '@material-ui/core';
import Lottie from 'react-lottie';
import React from 'react';
import PropTypes from 'prop-types';
import documentLottie from '../WaitingForBlockchain/document.json';
import { useStyles } from './styles';

const DocumentLoader = ({ title, progress, count, completedCount }) => {
  const classes = useStyles();

  return (
    <div className={classes.contentWrapper}>
      <Typography style={{ marginTop: 30 }}>
        <strong>{title}</strong>
      </Typography>
      <Lottie
        options={{
          loop: true,
          autoplay: true,
          // eslint-disable-next-line global-require
          animationData: documentLottie,
        }}
        height={200}
        width={200}
      />
      <Typography style={{ marginBottom: 40 }}>
        <strong>
          {`${Math.round(progress)}%`}
          <span style={{ paddingLeft: 10, paddingRight: 10 }}> - </span>
          {completedCount}/{count}
        </strong>
      </Typography>
    </div>
  );
};

DocumentLoader.propTypes = {
  title: PropTypes.string,
  progress: PropTypes.number,
  count: PropTypes.number,
  completedCount: PropTypes.number,
};

export default DocumentLoader;
